import React from 'react';
import { Avatar } from './Avatar';
import { USERS, VERSIONS } from './data';
import { Version } from './types';
interface SidebarProps {
  currentUser: string;
  activeVersionId: string;
  onVersionChange: (id: string) => void;
  onUserChange: (uid: string) => void;
  onLensChange: (lens: string) => void;
}
export function Sidebar({
  currentUser,
  activeVersionId,
  onVersionChange,
  onUserChange,
  onLensChange
}: SidebarProps) {
  return <aside style={{
    background: '#FFF',
    borderRight: '1px solid #E6E4DF',
    padding: '22px 14px',
    display: 'flex',
    flexDirection: 'column'
  }} data-id="element-189">
      {/* Logo */}
      <div style={{
      fontFamily: "'Lora', Georgia, serif",
      fontSize: 21,
      display: 'flex',
      alignItems: 'center',
      gap: 7,
      marginBottom: 24
    }} data-id="element-190">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1C2530" strokeWidth="2.2" data-id="element-191">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-192" />
        </svg>
        Luthor
      </div>

      {/* Record context */}
      <div style={{
      padding: '10px 10px',
      background: '#F7F5F2',
      borderRadius: 8,
      marginBottom: 20
    }} data-id="element-193">
        <div style={{
        fontSize: 9,
        color: '#94A3B8',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        marginBottom: 4
      }} data-id="element-194">
          Record
        </div>
        <div style={{
        fontSize: 12.5,
        fontWeight: 700,
        color: '#1C2530',
        lineHeight: 1.35,
        marginBottom: 2
      }} data-id="element-195">
          Flagship Equity — Digital Display
        </div>
        <div style={{
        fontSize: 10,
        color: '#8896A6',
        fontFamily: "'JetBrains Mono', monospace"
      }} data-id="element-196">
          AD-20241-S
        </div>
        <div style={{
        display: 'flex',
        gap: 5,
        marginTop: 8,
        flexWrap: 'wrap'
      }} data-id="element-197">
          <span style={{
          fontSize: 9,
          fontWeight: 600,
          padding: '2px 6px',
          borderRadius: 4,
          background: '#EBF5F3',
          color: '#1A6B5C'
        }} data-id="element-198">
            Q1 Brand
          </span>
          <span style={{
          fontSize: 9,
          fontWeight: 600,
          padding: '2px 6px',
          borderRadius: 4,
          background: '#F0EDE8',
          color: '#5A6B7C'
        }} data-id="element-199">
            Digital
          </span>
        </div>
      </div>

      {/* Versions */}
      <div style={{
      fontSize: 9,
      fontWeight: 700,
      color: '#94A3B8',
      textTransform: 'uppercase',
      letterSpacing: '0.06em',
      marginBottom: 6,
      paddingLeft: 4
    }} data-id="element-200">
        Versions
      </div>
      <div style={{
      position: 'relative'
    }} data-id="element-201">
        <div style={{
        position: 'absolute',
        left: 17,
        top: 12,
        bottom: 12,
        width: 1.5,
        background: '#E6E4DF'
      }} data-id="element-202" />
        {VERSIONS.map((ver: Version, i: number) => {
        const blocked = ver.blockers.length > 0;
        const active = ver.id === activeVersionId;
        const col = blocked ? '#B44D4D' : '#16785E';
        return <div key={ver.id} onClick={() => onVersionChange(ver.id)} style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          padding: '7px 10px',
          borderRadius: 7,
          background: active ? '#F7F5F2' : 'transparent',
          cursor: 'pointer',
          position: 'relative',
          zIndex: 1
        }} data-id="element-203">
              <div style={{
            width: 10,
            height: 10,
            borderRadius: '50%',
            background: active ? col : '#D1D5DB',
            border: i === VERSIONS.length - 1 ? `2px solid ${col}` : 'none',
            flexShrink: 0
          }} data-id="element-204" />
              <div style={{
            flex: 1
          }} data-id="element-205">
                <span style={{
              fontSize: 11.5,
              fontWeight: active ? 700 : 500,
              color: active ? '#1C2530' : '#5A6B7C'
            }} data-id="element-206">
                  {ver.label}
                </span>
                <span style={{
              fontSize: 9.5,
              color: '#94A3B8',
              marginLeft: 5
            }} data-id="element-207">
                  {ver.time}
                </span>
              </div>
              {blocked ? <span style={{
            fontSize: 10,
            fontWeight: 800,
            color: '#B44D4D'
          }} data-id="element-208">
                  {ver.blockers.length} ✕
                </span> : <span style={{
            fontSize: 10,
            fontWeight: 800,
            color: '#16785E'
          }} data-id="element-209">
                  ✓
                </span>}
            </div>;
      })}
      </div>

      {/* Role Switcher */}
      <div style={{
      marginTop: 'auto'
    }} data-id="element-210">
        <div style={{
        fontSize: 8,
        fontWeight: 700,
        color: '#94A3B8',
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        marginBottom: 6
      }} data-id="element-211">
          Switch Role
        </div>
        {Object.entries(USERS).map(([key, u]) => <button key={key} onClick={() => {
        onUserChange(key);
        onLensChange(u.role === 'reviewer' ? 'compliance' : 'marketing');
      }} style={{
        display: 'flex',
        alignItems: 'center',
        gap: 7,
        width: '100%',
        padding: '6px 8px',
        borderRadius: 6,
        marginBottom: 3,
        border: currentUser === key ? `1.5px solid ${u.color}` : '1px solid transparent',
        background: currentUser === key ? u.color + '10' : 'transparent',
        cursor: 'pointer',
        fontFamily: 'inherit',
        textAlign: 'left'
      }} data-id="element-212">
            <Avatar uid={key} size={22} data-id="element-213" />
            <div data-id="element-214">
              <div style={{
            fontSize: 11,
            fontWeight: 600
          }} data-id="element-215">
                {u.name}
              </div>
              <div style={{
            fontSize: 9,
            color: '#8896A6'
          }} data-id="element-216">
                {u.title}
              </div>
            </div>
          </button>)}
      </div>
    </aside>;
}
function NavItem({
  icon,
  label,
  badge,
  active
}: {
  icon: string;
  label: string;
  badge?: number;
  active?: boolean;
}) {
  return <button style={{
    display: 'flex',
    alignItems: 'center',
    gap: 9,
    padding: '9px 11px',
    borderRadius: 7,
    fontSize: 13,
    fontWeight: active ? 600 : 500,
    color: active ? '#1A6B5C' : '#5A6B7C',
    background: active ? '#EBF5F3' : 'transparent',
    border: 'none',
    cursor: 'pointer',
    fontFamily: 'inherit',
    textAlign: 'left',
    width: '100%'
  }} data-id="element-217">
      <span style={{
      width: 18,
      textAlign: 'center'
    }} data-id="element-218">
        {icon}
      </span>
      {label}
      {badge && <span style={{
      marginLeft: 'auto',
      fontSize: 9,
      fontWeight: 800,
      background: '#FEF2F2',
      color: '#B44D4D',
      padding: '2px 6px',
      borderRadius: 7
    }} data-id="element-219">
          {badge}
        </span>}
    </button>;
}